import { render, staticRenderFns } from "./RegisterCalendar.vue?vue&type=template&id=f2cbe030&"
import script from "./RegisterCalendar.vue?vue&type=script&lang=js&"
export * from "./RegisterCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports